// ============================================================
//  MASAMADREAM — History Screen
//  Fase 4: lista de procesos archivados con rating
// ============================================================

import { PROCESSES } from './data.js';

const DATE_FMT = { day: 'numeric', month: 'short', year: 'numeric' };

export function renderHistory(store) {
  const container = document.getElementById('mm-history-list');
  if (!container) return;

  const { history } = store.load();

  container.innerHTML = '';

  if (!history || history.length === 0) {
    container.innerHTML = `
      <div class="mm-empty-state">
        <span class="mm-empty-state-icon">📖</span>
        <span class="mm-empty-state-text">Todavía no has completado ningún proceso.</span>
      </div>`;
    return;
  }

  // Newest first
  [...history].reverse().forEach((proc, idx) => {
    const pData     = PROCESSES[proc.type];
    const emoji     = pData?.emoji || '🍞';
    const label     = pData?.label || proc.type.toUpperCase();
    const totalDays = pData?.totalDays || '?';

    const startDate = new Date(proc.startDate).toLocaleDateString('es-CR', DATE_FMT);
    const endDate   = proc.endDate
      ? new Date(proc.endDate).toLocaleDateString('es-CR', DATE_FMT)
      : '—';

    const daysCompleted = proc.completedIds?.length || 0;
    const totalActs     = pData?.activities?.length || 1;
    const pct           = Math.round((daysCompleted / totalActs) * 100);

    const outcomeLabel = {
      completed: '✅ Completado',
      abandoned: '🚫 Abandonado',
    }[proc.outcome] || '📁 Archivado';

    const outcomeClass = proc.outcome === 'completed' ? 'is-success' : 'is-abandoned';

    // Stars
    const starsHtml = [1,2,3,4,5].map(n =>
      `<span class="mm-hist-star ${n <= (proc.rating || 0) ? 'is-filled' : ''}">★</span>`
    ).join('');

    const card = document.createElement('div');
    card.className = 'mm-hist-card';
    card.setAttribute('role', 'listitem');

    card.innerHTML = `
      <div class="mm-hist-card-header">
        <span class="mm-hist-emoji" aria-hidden="true">${emoji}</span>
        <div class="mm-hist-info">
          <div class="mm-hist-label">${label}</div>
          <div class="mm-hist-dates">${startDate} → ${endDate}</div>
        </div>
        <span class="mm-hist-outcome ${outcomeClass}">${outcomeLabel}</span>
      </div>

      <div class="mm-hist-bar-wrap">
        <div class="mm-hist-bar">
          <div class="mm-hist-bar-fill ${outcomeClass}" style="width:${pct}%"></div>
        </div>
        <span class="mm-hist-pct">${daysCompleted}/${totalActs} actividades</span>
      </div>

      ${proc.rating ? `
        <div class="mm-hist-rating">
          ${starsHtml}
        </div>` : ''}
    `;

    container.appendChild(card);
  });

  // Summary stats
  const completed = history.filter(p => p.outcome === 'completed').length;
  const statsEl   = document.getElementById('mm-history-stats');
  if (statsEl) {
    statsEl.innerHTML = `
      <span class="mm-hist-stat"><strong>${history.length}</strong> procesos</span>
      <span class="mm-hist-sep">·</span>
      <span class="mm-hist-stat"><strong>${completed}</strong> completados</span>
    `;
  }
}
